import faker from "@faker-js/faker";
import { registerables } from "chart.js";

export const getLabels = () => {
  const labels = [];
  for (let hour = 0; hour <= 24; hour++) {
    for (let minute = 0; minute < 60; minute++) {
      if (hour === 24 && minute > 0) break; // Stop after "24:00"
      const formattedHour = String(hour).padStart(2, '0');
      const formattedMinute = String(minute).padStart(2, '0');
      let value = minute === 0 ? hour : `${formattedHour}.${formattedMinute}`
      labels.push(value);
    }
  }
  return labels;
}

export const dataSpace = (tempature, label) => {
  return {
    labels: label,
    datasets: [
      {
        label: "Temperature",
        data: tempature,
        // data: [18, 25, 28, 3, 5, 18],
        borderColor: "#00A6EF",
        pointBackgroundColor: "#F9A825",
        pointBorderColor: "white",
        pointHoverRadius: 10,
        pointHoverBackgroundColor: "#F9A825",
        tension: 0.4,
        backgroundColor: "rgba(0, 166, 239, 0.2)",
        fill: true,
        yAxisID: "y",
      },
    ],
  };
};

export const plugins = [
  {
    beforeDraw: (chart) => {
      if (chart.tooltip._active && chart.tooltip._active.length) {
        const ctx = chart.ctx;
        ctx.save();
        const activePoint = chart.tooltip._active[0];
        ctx.beginPath();
        ctx.setLineDash([5, 7]);
        ctx.moveTo(activePoint.element.x, chart.chartArea.bottom);
        ctx.lineTo(activePoint.element.x, activePoint.element.y);
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#00A6EF";
        ctx.stroke();
        ctx.restore();
      }
    },
  },
];
const titleToolTip = (tooltipItems) => {
  return tooltipItems[0].dataset.label;
};
const labelToolTip = (labelToolItems) => {
  return labelToolItems.formattedValue + "°C";
};
export const optionsSpace = {
  elements: {
    point: {
      radius: 0,
    },
  },
  tooltips: {
    enabled: true,
  },
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      // grace: "50",
      grid: {
        display: true,
      },
      ticks: {
        callback: function (value) {
          return value + "°C";
        },
      },
    },
  },
};
export const options = (maxWidth765, maxWidth500, label) => {
  return {
    elements: {
      point: {
        radius: 0,
      },
    },
    interaction: {
      mode: "index",
    },
    hover: {
      intersect: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    plugins: {
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
      legend: {
        display: false,
      },
      tooltip: {
        caretPadding: 20,
        yAlign: "bottom",
        titleMarginBottom: 0,
        displayColors: false,
        boxWidth: 0,
        titleFont: {
          size: 13,
        },
        padding: 8,
        bodyFont: {
          size: 25,
          weight: "bolder",
          lineHeight: 1.5,
        },
        bodySpacing: 10,
        callbacks: {
          // beforeTitle: function (context) {
          //   return "Tempature";
          // },

          // beforeBody: function (context) {
          //   let findData = context.find(
          //     (c) =>
          //       c.dataset && c.dataset.label && c.dataset.label === "Temperature"
          //   );
          //   if (findData && findData.formattedValue) {
          //     return findData.formattedValue + "°C";
          //   }
          // },

          // afterBody: function (context) {
          //   // console.log("context", context);
          //   return "+ggg";
          // },
          title: function (labelToolItems) {
            console.log("labelToolItems", labelToolItems);
            return labelToolItems[0].label;
          },
          label: function (labelToolItems) {
            return "Temperature: " + labelToolItems.formattedValue + "°C";
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          // maxTicksLimit: maxWidth500 ? 6 : maxWidth765 ? 12 : 24,
          maxRotation: 0,
          minRotation: 0,
          callback: function (value, index, values) {
            if (label[index].toString().indexOf(".") == -1) {
              return label[index];
            }
          },
        },
      },
      y: {
        // stacked: true,
        // grace: "50",
        beginAtZero: true,
        type: "linear",
        position: "left",
        grid: {
          display: true,
        },
        min: 0,
        max: 40,
        ticks: {
          stepSize: 5,
          callback: function (value) {
            return value + "°C";
          },
        },
      },
      
    },
  };
};
